import { useState, useContext, useEffect } from "react";
import utilities from "./utilities";
import { PluginsValue } from "../contexts/plugins";
import { db } from "../firebase";

export default function () {
  const plugins = useContext(PluginsValue);
  const [_utilities, setUtilities] = useState([]);

  useEffect(() => {
    const _utilities = [];

    const utilPromises = Object.values(plugins)
      .filter((x) => x.plugin.utilities)
      .map(async (v) => {
        const snap = await db
          .collection("plugins")
          .doc(v.plugin.name)
          .collection("versions")
          .doc(v.version)
          .collection("utilities")
          .get();
        snap.docs.forEach((doc) => {
          _utilities.push({
            ...doc.data(),
            name: v.plugin.name.toUpperCase() + doc.data().name,
          });
        });
      });
    Promise.all(utilPromises).then(() => {
      setUtilities([...utilities, ..._utilities]);
    });
  }, [plugins]);

  return _utilities;
}
